module.exports = __webpack_public_path__ + "static/california-1b1a1ade5f767d6362ad390b2768eabe.jpg";